"use strict";

// Mutation Observer to append sId parameter to Kobo ebook URLs
(function () {
  var CATEGORY_PAGE_PATTERN = /\/\w\w\/\w\w\/(?:e|audio)books\//;
  var PRODUCT_PAGE_PATTERN = /\/\w\w\/\w\w\/(?:e|audio)book\//;

  function isCategoryPage(url) {
    return CATEGORY_PAGE_PATTERN.test(url || window.location.pathname);
  }

  function isNotCategoryPage(url) {
    return !isCategoryPage(url);
  }

  function isProductPage(url) {
    return PRODUCT_PAGE_PATTERN.test(url || window.location.pathname);
  }

  function isNotProductPage(url) {
    return !isProductPage(url);
  }

  function isSideNavigationElement(element) {
    return element.closest('[data-kobo-widget="ChildCategoriesWidget"]');
  }

  function isSearchIdPresent(url, searchId) {
    return (url || window.location).indexOf("sId=".concat(searchId)) >= 0;
  }

  function isSearchSessionIdPresent(url, ssId) {
    return (url || window.location).indexOf("ssId=".concat(ssId)) >= 0;
  }

  function hasNoTrackingParams(sId, ssId) {
    return !sId && !ssId;
  } // Helper function to process a single link element


  function processLink(linkElement, sId, ssId) {
    var href = linkElement.getAttribute('href');
    if (isNotProductPage(href) || isSideNavigationElement(linkElement)) return;

    if (sId && !isSearchIdPresent(href, sId)) {
      href = addSearchIdToHrefAsQueryString(href, sId);
    }

    if (ssId && !isSearchSessionIdPresent(href, ssId)) {
      href = addSearchSessionIdToHrefAsQueryString(href, ssId);
    }

    linkElement.setAttribute('href', href);
  } // Process existing links on page load


  function processExistingLinks() {
    if (isNotCategoryPage()) return;
    var sId = getSearchIdFromUrl();
    var ssId = getSearchSessionIdFromUrl();

    if (hasNoTrackingParams(sId, ssId)) {
      return;
    }

    var links = document.querySelectorAll('a[href]');
    links.forEach(function (link) {
      return processLink(link, sId, ssId);
    });
  } // Extract sId parameter from current page URL


  function getSearchIdFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('sId');
  }

  function getSearchSessionIdFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('ssId');
  } // Check if URL matches Kobo ebook/audiobook pattern and modify it


  function addSearchIdToHrefAsQueryString(url, sId) {
    if (isNotProductPage(url)) return url;

    try {
      // Handle relative URLs by creating absolute URL
      var urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set('sId', sId);
      return urlObj.href;
    } catch (e) {
      return url;
    }
  }

  function addSearchSessionIdToHrefAsQueryString(url, ssId) {
    if (isNotProductPage(url)) return url;

    try {
      var urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set('ssId', ssId);
      return urlObj.href;
    } catch (e) {
      return url;
    }
  } // Process newly added nodes
  // Create and configure mutation observer


  function initMutationObserver() {
    var sId = getSearchIdFromUrl();
    var ssId = getSearchSessionIdFromUrl();

    if (hasNoTrackingParams(sId, ssId) || isNotCategoryPage()) {
      return;
    }

    processExistingLinks();
    if (!window.Kobo) window.Kobo = {};
    if (!window.Kobo.MutationObservers) window.Kobo.MutationObservers = {};
    window.Kobo.MutationObservers.SearchIdObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          var addedNodes = Array.from(mutation.addedNodes);
          addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'A' && node.hasAttribute('href')) {
                processLink(node, sId, ssId);
              }

              var links = node.querySelectorAll('a[href]');
              links.forEach(function (link) {
                return processLink(link, sId, ssId);
              });
            }
          });
        }
      });
    });
    window.Kobo.MutationObservers.SearchIdObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMutationObserver);else initMutationObserver();
})();